"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapService = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var index_1 = require("./index");
var MAP_OPTIONS = {
    /* Disable clicking points of interest. This makes it confusing when trying to click on collections. */
    clickableIcons: false,
    /* Disable 45° camera angle in satellite map mode. Only top-down angle will position collections accurately. */
    tilt: 0,
    /* Feature works but is not tested. Disable until asked for. */
    rotateControl: false
};
var MapService = /** @class */ (function () {
    function MapService() {
        this.__priority = 100;
        this.isReady = false;
    }
    MapService.prototype.init = function () {
        var _this = this;
        this.isReadyPromise = new Promise(function (resolve) {
            var waitForGoogleMaps = index_1.Services.Window.window.setInterval(function () {
                if (typeof google === 'undefined') {
                    return;
                }
                index_1.Services.Window.window.clearTimeout(waitForGoogleMaps);
                _this.setIsReady();
                resolve();
            }, 10);
        });
    };
    Object.defineProperty(MapService.prototype, "map", {
        /**
         * Fetch Google Map instance, reusing existing instance to avoid impacting Google Maps API quota.
         */
        get: function () {
            if (!this.isReady) {
                throw new Error('Cannot fetch map before Google Maps API loaded');
            }
            if (this.mapInstance == null) {
                var mapEl = index_1.Services.Window.document.createElement('div');
                mapEl.style.width = '100%';
                mapEl.style.height = '100%';
                this.mapInstance = new google.maps.Map(mapEl, MAP_OPTIONS);
            }
            return this.mapInstance;
        },
        enumerable: false,
        configurable: true
    });
    MapService.prototype.attach = function (el) {
        var map = this.map;
        if (map == null) {
            return null;
        }
        el.appendChild(map.getDiv());
        return map;
    };
    MapService.prototype.setIsReady = function () {
        this.isReady = true;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], MapService.prototype, "isReady", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], MapService.prototype, "setIsReady", null);
    return MapService;
}());
exports.MapService = MapService;
//# sourceMappingURL=map.service.js.map